import { atom } from 'jotai';
import { atomWithLazy } from 'jotai/utils';
import { IAppConfigDataModel } from '../../data-models/app-config.data-model';
import { IPreferencesV3DataModel } from '../../data-models/preferences-v3.data-model';
import { getForesightStore } from '../../util/jotai-store';
import { readThrough } from '../boot-cache/bootCache';
import { fetchAppConfig } from '../queries/MaggieConfigQueries';
import { getAllPreferences } from '../queries/MaggiePreferencesQueries';

// The boot's own reads, held in atoms so the early boot can start them before the boot hooks mount; the
// hooks then await the request already in flight. Read once per page: later refreshes call the queries.

/** A configuration that differs from the cached one the boot started from, for the boot to apply. */
export const appConfigRefreshAtom = atom<IAppConfigDataModel | null>(null);

/** The failure of the configuration refresh behind a cached boot, for the boot to end as a failed read would. */
export const appConfigRefreshErrorAtom = atom<unknown>(null);

export const appConfigRequestAtom = atomWithLazy(() =>
  readThrough('configuration', fetchAppConfig, {
    onFresh: (fresh) => getForesightStore().set(appConfigRefreshAtom, fresh),
    onRefreshError: (error) => getForesightStore().set(appConfigRefreshErrorAtom, error),
  })
);

/** Preferences that differ from the cached ones the boot started from, for the boot to apply. */
export const preferencesRefreshAtom = atom<IPreferencesV3DataModel<unknown>[] | null>(null);

// A failed preferences refresh is left alone: a failed direct read already starts the service empty and lets
// the boot succeed, so the refresh behind a cached boot does the same.
export const preferencesRequestAtom = atomWithLazy(() =>
  readThrough('preferences', () => getAllPreferences(), {
    onFresh: (fresh) => getForesightStore().set(preferencesRefreshAtom, fresh),
  })
);
